import type { IconSvgObject } from './types';

const DashedLine01Icon: IconSvgObject = [
  ["path", { d: "M2 12H4.5M7.5 12H10M13 12H15.5M18.5 12H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default DashedLine01Icon;
